const state = {
  goodsType: {
    base: "基础包",
    temporary: "叠加包",
  },
  temporaryType: {
    flow: "流量",
    voice: "语音",
    sms: "短信",
  },
  effectiveDuration: {
    month: "月",
    month2: "两月",
    quarter: "季度",
    half_year: "半年",
    year: "年",
    day: "天",
  },
  monthType: {
    natural: "自然月", // natural , full
    full: "30天",
  },
  operatorType: {
    mobile: "移动",
    unicom: "联通",
    telecom: "电信",    guangdian: "广电",    yizheng: "一正",
  },
}
const mutations = {

}
const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/goods.js